import { useCallback, useState } from 'react';

type Params = { [key: string]: unknown };

export interface IUseToggle {
	onOpen: (arg?: Params) => void;
	onClose: () => void;
	onToggle: () => void;
	isOpen: boolean;
	params: Params;
}

export function useToggle(initialState: boolean = false): IUseToggle {
	const [isOpen, setIsOpen] = useState<boolean>(initialState);

	const [params, setParams] = useState<Params>({});

	const onOpen = useCallback((params = {}) => {
		if (params) setParams(params);

		setIsOpen(true);
	}, []);

	const onClose = useCallback(() => {
		setIsOpen(false);
	}, []);

	const onToggle = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	return { onOpen, onClose, onToggle, isOpen, params };
}
